import store from './position-store';
import routes from './position-routes';

const components = [];
const mixins = [];
const filters = [];
const directives = [];

export default {
  components,
  mixins,
  filters,
  directives,
  routes,
  store
};



// WEBPACK FOOTER //
// ./src/entities/position/position-module.js